import React, {useContext, useEffect, useRef, useState} from "react";
import Column from "@amzn/meridian/column";
import Row from "@meridian/components/row";
import RefreshTimer from "../../util/RefreshTimer";
import Alert from "@amzn/meridian/alert";
import {FormattedMessage} from "react-intl";
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import Button from "react-bootstrap/Button";
import {TrafficLightDeviceOverviewContext} from "./context/TrafficLightOverviewContext";
import {PermissionsContext} from "../../permissions/PermissionsContext";
import AddControllerModal from "./modal/AddControllerModal";
import Loader from "../../loader/Loader";
import UpdateDeviceDetailsResponse from "./modal/UpdateDeviceDetailsResponse";

const TrafficLightControllerOverview = () => {
    const {viewModel, dispatch} = useContext(TrafficLightDeviceOverviewContext);
    const {isManager} = useContext(PermissionsContext);
    const tableEndRef = useRef(null)
    const [controllerDeviceInformation, setControllerDeviceInformation] = useState([]);
    const [openAddNewControllerModal, setOpenAddNewControllerModal] = useState(false)
    const [sortColumn, setSortColumn] = useState('name');
    const [sortDirection, setSortDirection] = useState('ascending')

    const fetchDeviceInformation = () => {
        dispatch({type: 'LOAD_DATA', data: {dispatcher: dispatch}});
    }

    useEffect(() => {
        if(!viewModel.deviceInformation.assetDetails) {
            fetchDeviceInformation();
        } else {
            setControllerDeviceInformation(viewModel.deviceInformation.assetDetails)
        }
    },[viewModel.deviceInformation.assetDetails])

    const deleteDevice = (index) => {
        let updatedControllerData = [...controllerDeviceInformation]
        dispatch({type: 'DELETE_CONTROLLER_DATA', data: {dispatcher: dispatch, mac: controllerDeviceInformation[index].assetLabel.value}});
        updatedControllerData.splice(index,1)
        setControllerDeviceInformation(updatedControllerData)
    }

    const onSort = (sortDetails) => {
        const sortedDeviceList = Object.values(controllerDeviceInformation);
        sortedDeviceList && sortedDeviceList.sort((a, b) => {
            if (a['assetAttributes'][sortDetails.sortColumn] < b['assetAttributes'][sortDetails.sortColumn]) {
                return sortDetails.sortDirection === "ascending" ? -1 : 1
            }
            if (a['assetAttributes'][sortDetails.sortColumn] > b['assetAttributes'][sortDetails.sortColumn]) {
                return sortDetails.sortDirection === "ascending" ? 1 : -1
            }
            return 0
        })

        setSortColumn(sortDetails.sortColumn);
        setSortDirection(sortDetails.sortDirection);
        setControllerDeviceInformation(sortedDeviceList)
    }

    if (viewModel.loadingOverview) {
        return (<Loader/>)
    } else {
        return (
            <Row widths="100%" alignmentVertical="top" spacingInset="none none large none">
                <Column>
                    <Row width="100%" widths={["100", "fill", "100"]}>
                        <RefreshTimer deps={[viewModel]}/>
                    </Row>
                    {
                        controllerDeviceInformation.length === 0 ?
                            <Alert type="informational" size="small">
                                <FormattedMessage id="alert.device"
                                                  defaultMessage="No controller present for this station."/>
                            </Alert> :
                            <Table
                                headerRows={1}
                                spacing="small"
                                showDividers={true}
                                showStripes={true}
                                sortColumn={sortColumn}
                                onSort={onSort}
                                sortDirection={sortDirection}
                            >
                                <TableRow highlightOnHover={false}>
                                    <TableCell sortColumn="name">
                                        <FormattedMessage id="device.name" defaultMessage="Name"/>
                                    </TableCell>
                                    <TableCell sortColumn="mac">
                                        <FormattedMessage id="device.mac_ip" defaultMessage="MAC/IP"/>
                                    </TableCell>
                                    <TableCell>
                                    </TableCell>
                                </TableRow>
                                {controllerDeviceInformation.map((device, index) => (
                                    <TableRow key={index} highlightOnHover={true}>
                                        <TableCell>
                                            <b>{device.assetAttributes.name}</b>
                                        </TableCell>
                                        <TableCell>
                                            <Column>
                                                <b>{device.assetAttributes.mac}</b>
                                                {device.assetAttributes.ip}
                                            </Column>
                                        </TableCell>
                                        <TableCell>
                                            <Button variant="danger" size="small" onClick={() => deleteDevice(index)}
                                                    disabled={!isManager}>Delete Device</Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </Table>
                    }
                    <Row width="100%" widths={["100", "fill", "100"]}>
                        <Button variant="info" size="small" onClick={() => setOpenAddNewControllerModal(true)}
                                disabled={!isManager}>
                            <FormattedMessage id="device.add_device_button_modal" defaultMessage="Add Device Configuration"/>
                        </Button>
                    </Row>
                    <AddControllerModal open={openAddNewControllerModal} setOpen={setOpenAddNewControllerModal}/>
                    <UpdateDeviceDetailsResponse/>
                    <div ref={tableEndRef}/>
                </Column>
            </Row>
        )
    }
}

export default TrafficLightControllerOverview;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/trafficlightdevice/TrafficLightControllerOverview.js